import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Button from "../../../../common/Button";
import Title from "./Title";
import AnsweringInfo from "../../../learning/presentational/header/answeringInfo/AnsweringInfo";

const Header = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const { Closer } = props;

  return (
    <div className="header dark">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <Title>{ answeringQuestions.data.stgNm }</Title>
            <Closer><Button className="btn-close-wrap">닫기</Button></Closer>
          </div>
          <div className="headerBox_body">
            <AnsweringInfo />
          </div>
        </div>
      </div>
    </div>
  );

};

Header.defaultProps = {
  Closer : Fragment
};

export default Header;
